/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event'

import React from 'react'
import * as microConfig from '@/views/micro/config'
import useStore from '@/store/persistStore'
import { useNavigate } from 'react-router-dom'
import config from '@/config'
import { tree2Array } from '@/utils'
import useGlobalThemeStore from '@/store/globalTheme'

interface LoginInfo {
  token: string
  username?: string
  name?: string
  [key: string]: any
}

const Login: React.FC = () => {
  const navigate = useNavigate()
  const { setState } = useStore
  const { colorPrimary } = useGlobalThemeStore()
  const getLoginInfo = (info: LoginInfo) => {
    setState({
      token: info.token,
      loginInfo: info,
      permissionCodes: tree2Array(info.privileges, 'childrenPrivileges').map(
        (item: any) => item.code
      ),
    })
    if (info?.token) {
      setTimeout(() => {
        navigate('/')
      }, 500)
    }
  }
  return (
    <micro-app
      name={microConfig.MICRO_APPS[0].name}
      url={microConfig.MICRO_APPS[0].url}
      defaultPage={microConfig.BASE_ROUTE.login}
      onDataChange={(e: any) => getLoginInfo(e.detail.data.loginInfo || {})}
      data={{
        title: 'iKG',
        version: config.version,
        theme: {
          colorPrimary
        }
      }}
    />
  )
}

export default Login

export const Agreement: React.FC = () => {
  const { colorPrimary } = useGlobalThemeStore()
  return (
    <micro-app
      name={microConfig.MICRO_APPS[0].name}
      url={microConfig.MICRO_APPS[0].url}
      defaultPage={microConfig.BASE_ROUTE.agreement}
      data={{
        theme: {
          colorPrimary
        }
      }}
    />
  )
}

export const PrivacyPolicy: React.FC = () => {
  const { colorPrimary } = useGlobalThemeStore()
  return (
    <micro-app
      name={microConfig.MICRO_APPS[0].name}
      url={microConfig.MICRO_APPS[0].url}
      defaultPage={microConfig.BASE_ROUTE.privacyPolicy}
      data={{
        theme: {
          colorPrimary
        }
      }}
    />
  )
}
